import { getInputProps, useField } from "@conform-to/react";

import { InputProps, Input as InputRadix } from "~/components/ui/input";
import { cn } from "~/lib/utils";

export function Input({
    name,
    type,
    className,
    ...props
}: InputProps & { type: Parameters<typeof getInputProps>[1]["type"] }) {
    const [meta] = useField(name);
    const inputProps = getInputProps(meta, { type });
    return (
        <InputRadix
            type="text"
            {...inputProps}
            data-1p-ignore
            key={inputProps.key}
            {...props}
            className={cn({ "border-destructive": !!meta.errors }, className)}
        />
    );
}
